import App from './App.svelte';

const foodGenres = [
  'American',
  'Brazillian',
  'Chinese',
  'English',
  'French',
  'German',
  'Indian',
  'Italian',
  'Japanese',
  'Korean',
  'Mexican',
  'Nordic',
  'Thai'
];

const app = new App({
  target: document.body,
  props: {
    genres: foodGenres
  }
});

export default app;
